import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {AutoTrackingLazy} from "@containers/map/containers/autoTracking/AutoTracking.lazy";


const AutoTrackingPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <AutoTrackingLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default AutoTrackingPage;